import { Controller } from '@nestjs/common';

@Controller('invoice')
export class InvoiceController {}
